import { FunctionComponent, useState } from 'react'
import { Box, Typography, Tabs, Tab } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { SPACING } from '../../constants'
import WalletNotifications from './WalletNotifications'
import SmsBroadcasts from './SmsBroadcasts'

/**
 * Notify hosts two channels as separate composers rather than one screen with
 * a channel picker.
 *
 * The constraints do not overlap: a wallet push caps at 150 characters and
 * costs nothing to send, while a text has no practical cap, bills per
 * segment, and only reaches members who affirmatively agreed to receive
 * marketing. One form trying to serve both would have to hide or contradict
 * half its own rules depending on the selection.
 *
 * The audience segments are shared, though — see NotificationAudience on the
 * backend — so "all members" means the same people on both.
 */
const Notify: FunctionComponent = () => {
  const styles = useStyles()
  const [channel, setChannel] = useState<'wallet' | 'sms'>('wallet')

  return (
    <Box className={styles.container}>
      <Typography variant="h4" gutterBottom>
        Notify
      </Typography>

      <Tabs
        value={channel}
        onChange={(_, value) => setChannel(value)}
        className={styles.tabs}
      >
        <Tab value="wallet" label="Wallet notification" sx={tabSx} />
        <Tab value="sms" label="Text message" sx={tabSx} />
      </Tabs>

      {channel === 'wallet' ? <WalletNotifications /> : <SmsBroadcasts />}
    </Box>
  )
}

// sx rather than makeStyles: MUI v5's emotion styles win over v4 makeStyles
// classes on MUI components, so textTransform set there would be ignored.
const tabSx = {
  textTransform: 'none',
  fontWeight: 600,
  fontSize: 15,
} as const

const useStyles = makeStyles({
  container: {
    padding: SPACING * 2,
  },
  tabs: {
    marginBottom: SPACING * 2,
  },
})

export default Notify
